import { Button } from 'rizzui';
import cn from '../utils/class-names';

interface Currency {
  label: string;
  value: string;
  feeType: "percentage" | "base_fee";
  feeRate: string;
  transactionMode: "payment" | "payout";
  minWithdraw: string;
  exchangeRate: string;
}


interface FormFooterProps {
  className?: string;
  altBtnText?: string;
  submitBtnText?: string;
  isLoading?: boolean;
  handleAltBtn?: () => void;
  handleUpdate?: () => void;
  currencies: Currency[]
}

export const negMargin = '-mx-4 md:-mx-5 lg:-mx-6 3xl:-mx-8 4xl:-mx-10';

export default function FormFooter({
  isLoading,
  altBtnText = 'Save as Draft',
  submitBtnText,
  className,
  currencies,
  handleAltBtn,
}: FormFooterProps) {
  
const handleUpdate = ()=>{
  console.log(currencies)
}

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 z-10 flex items-center justify-end gap-4 border-t bg-white px-4 py-4 md:px-5 lg:px-6 3xl:px-8 4xl:px-10 dark:bg-gray-50',
        // 'fixed bottom-0 left-0 right-0 z-10 -mb-8 flex items-center justify-end gap-4 border-t bg-white px-4 py-4 md:px-5 lg:px-6 3xl:px-8 4xl:px-10 dark:bg-gray-50',
        className,
        negMargin
      )}
    >
      {/* <Button
        variant="outline"
        className="w-[300px]"
        onClick={handleAltBtn}
      >
        {altBtnText}
      </Button> */}
      <Button type="submit" onClick={handleUpdate} isLoading={isLoading} className="w-[120px] px-4">
        {submitBtnText}
      </Button>
    </div>
  );
}
